import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useIntl } from "react-intl";
import { IAlert } from "../../models/IAlert";
import { alertServices } from "../../services/alertsServices";

interface IProps {
  refetch: () => void;
  show: boolean;
  onHide: () => void;
  alert: IAlert;
}

export function AlertReview({ show, onHide, alert, refetch }: IProps) {
  const intl = useIntl();
  useEffect(() => {
    if(!alert.id){
      onHide();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alert])
  
  const dismissAlert = async () => {
    await alertServices.dismissAlert(alert.id);
    refetch();
    onHide();
  };
  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        keyboard={false}
        size="xl"
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            {intl.formatMessage({ id: "ALERTS.EXCEPTION.MESSAGE" })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{alert.message}</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={onHide}
            className="btn btn-light btn-elevate mx-1"
          >
            Close
          </button>
          <> </>
          <button
            type="button"
            onClick={dismissAlert}
            className="btn btn-success btn-elevate"
          >
            Mark as reviewed
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
